<template>
    <div style="background:#fff; margin-left:3px; "> 
        <el-table :data="tmpData " 
            border                            
            disabled-hover
            style="overflow:auto;margin-top:-8px;"
            size="small"
            ref="reftab"
            v-loading="v_loading"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            header-cell-class-name="clearPadding"
            :header-cell-style="{ 'color':'#389','text-align':'center'}"
            class="custom-table-border"
            :cell-style="{padding:'2px'}"
            :min-height="400"
            show-summary
            :summary-method="getSummary"
            :height="tabHeight" 
            highlight-current-row >
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1"  ></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column   v-for="(item ,index) in tabCol.filter(item=>item.thide=='N'||item.key=='SEL' )" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-input type="number" placeholder="数字框" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-tag  v-if="item.key=='STFG'&&scope.row['STFG']=='Y'" size="mini" type="success" effect="dark">已审核</el-tag>
                        <el-tag  v-else-if="item.key=='STFG'&&scope.row['STFG']!=='Y'" size="mini" type="info" effect="dark">未审核</el-tag>  
                        <el-checkbox v-else-if="item.edcss=='checkbox'" true-label="Y" :disabled="item.key!=='SEL'" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-image fit="scale-down" v-else-if="item.key=='IMGPATH'" style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">
                            <div slot="error"><i class="el-icon-picture-outline"></i></div>
                        </el-image>
                        <span v-else v-text="scope.row[item.key]"></span>
                    </template>
                </el-table-column> 
            </el-table-column>              
        </el-table>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
        </div> 
 
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>
import {  getBaseData } from '../../api/user' 
 
export default {
    //props:['v_table','tabCol' ],
    props: {
        v_key2:{
            type: String,
            default:'',
        } ,
 
        v_value2:{
            type: String,
            default:'',
        },
        v_table:{
            type: String,
        },
        tabCol:{
            type: Array,
        },
        v_cond:{
            type: String,
            default:'',
        },
        v_random:{
            type: String,
            default:'',
        },
    },
    data () {
        return {
            oper:'like',
            input_hold:'请输入内容... 按回车键以查询',
            v_loading:false,// select 绑定值
            txtparam:'', // input 绑定值
            dataCount:0,
            tmpData:[] ,// 
            allData:[] ,//表数据
            disabled:false,
            selAll:'N',
            operArr:[],
            promptWin:false,
            prompt:'',
            rowSize:50,
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            current:1,
            v_sel:'N',
 
            v_row:{},
        }
    },
    created () {
 
    },
    watch: {
        v_table:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
 
        } ,
        v_cond:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData()  
 
        } ,
        v_random:function(){ //侦测变量值改变时 执行此方法
            this.qryTabData() 
  
        } 
    },
    mounted () {   
 
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        this.qryTabData()
    },
    computed: {
        tabHeight() {
          return  window.innerHeight -135
        },
        scrollerHeight: function() {
            return (window.innerHeight - 80) + 'px';
        }, 
    },
    methods: { 
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =this.allData.map(item=>Number(item[column.property]));
                if(column.property.indexOf('AMT')>-1||column.property.indexOf('QTY')>-1){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ) 
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        //字段查询
        inputQry(){
            this.qryTabData()  
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryTabData()
        } ,
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize;
            this.tmpData = this.allData.slice(_start,_end);
        },
  
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.tmpData = this.allData          
            }else{
                this.tmpData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }
        },
        //查询表格数据
        qryTabData(){
            let cond_= this.v_cond 
 
            let v_cond ='',v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid, p_cond:cond_+v_cond,p_table: this.v_table},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.allData =res.result 
                    this.initPage() 
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs['reftab'].doLayout()
                        this.v_loading =false
                    })
                }else{
                    this.v_loading =false
                    this.promptWin=true
                    this.prompt=res.result
                }    
            }) 
            
        },
 
    }
}
 
</script>
<style scoped lang="less" >
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
 
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
 
</style>
